import { trainingPlansEvents } from "@Context/game/training-plans/training-plans-events";
import { useCallback, useEffect, useState } from "react";

export interface ITrainingPlanToast {
  open: boolean;
  title: string;
  message: string;
  isComplete: boolean;
}

const defaultToastState: ITrainingPlanToast = {
  open: false,
  title: "",
  message: "",
  isComplete: false,
};

/**
 * Presentation-state hook for Training Plans toast UI.
 *
 * Responsibility:
 * - Stores current toast payload and visibility state.
 * - Subscribes to toast events and maps them into renderable UI state.
 * - Exposes a simple hide action for the consumer component.
 */
export const useTrainingPlansToast = () => {
  const [toast, setToast] = useState<ITrainingPlanToast>(defaultToastState);

  const hideToast = useCallback(() => {
    setToast(previousState => ({
      ...previousState,
      open: false,
    }));
  }, []);

  useEffect(() => {
    return trainingPlansEvents.onShowToast(({ title, message, isComplete }) => {
      setToast({
        open: true,
        title,
        message,
        isComplete,
      });
    });
  }, []);

  return {
    hideToast,
    toast,
  };
};
